import { environment } from '../../../../environments/environment';

/**
 * Vrai uniquement pour une requête adressée à notre propre API (voir environment.apiUrl), jamais
 * pour un tiers (CDN, police de caractères, bundle i18n statique servi par un domaine différent
 * demain, etc.). Sert de garde-fou dans les intercepteurs auth pour ne jamais laisser fuiter le
 * token d'accès (Authorization) hors de nos propres services — voir audit sécurité 2026-09-02 :
 * avant ce garde-fou, authInterceptor attachait le token à CHAQUE requête HTTP sans distinction, y
 * compris les bundles /i18n/*.json (mêmes origine relative, mais aucune raison de les authentifier).
 */
export function isApiRequest(url: string): boolean {
  return url.startsWith(environment.apiUrl);
}
